(function () {
  document.querySelectorAll('.variant-color-section .variant-option__value').forEach(function (item) {
    const swatch = item.querySelector('.variant-option__swatch-media');
    if (!swatch) return;

    const preview = document.createElement('div');
    preview.className = 'variant-color-preview';
    const img = document.createElement('img');
    img.alt = '';
    preview.appendChild(img);
    item.appendChild(preview);

    let hideTimer = null;

    function showPreview() {
      clearTimeout(hideTimer);
      const imgSrc = swatch.getAttribute('data-hover-img');
      if (!imgSrc) return;
      img.src = imgSrc;

      const rect = swatch.getBoundingClientRect();
      if (rect.top < 180) {
        preview.classList.add('drop-down');
        preview.style.bottom = 'auto';
        preview.style.top = 'calc(95% + 0px)';
      } else {
        preview.classList.remove('drop-down');
        preview.style.top = 'auto';
        preview.style.bottom = 'calc(100% + 10px)';
      }

      preview.classList.add('visible');
    }

    function hidePreview() {
      hideTimer = setTimeout(function () {
        preview.classList.remove('visible');
      }, 100); // 100ms delay — enough time to move cursor into preview
    }

    // Swatch hover
    swatch.addEventListener('mouseenter', showPreview);
    swatch.addEventListener('mouseleave', hidePreview);

    // Preview hover — cancel hide if cursor moves into preview
    preview.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });
    preview.addEventListener('mouseleave', function () {
      hidePreview();
    });
  });
})();

function syncAddToCartClass() {
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (!addToCartBtn) return;

  const textEl = addToCartBtn.querySelector('[data-add-to-cart-text]');
  const btnText = textEl ? textEl.textContent.trim() : '';

  if (btnText === 'Add to cart') {
    addToCartBtn.classList.add('btn-cart-custom');
  }
}


document.addEventListener('DOMContentLoaded', function () {

  const colorSwatchSection = document.querySelector('.variant-color-section');
  if (!colorSwatchSection) return;

  const productForm = colorSwatchSection.closest('form');
  const variantSelect = productForm.querySelector('select[name="id"]');

  // The color <select> is the .selector-wrapper immediately preceding the swatch section
  const colorSelectorWrapper = colorSwatchSection.previousElementSibling;
  const colorSelect = colorSelectorWrapper ? colorSelectorWrapper.querySelector('select') : null;

  const allSelectors = Array.from(productForm.querySelectorAll('.single-option-selector'));
  const otherSelectors = allSelectors.filter(function (sel) { return sel !== colorSelect; });

  const swatches = document.querySelectorAll('input[name="color_swatch"]');

  // Visually hide the color select — swatches drive selection now, select stays functional
  if (colorSelectorWrapper) {
    colorSelectorWrapper.style.display = 'none';
  }

  function stripStatus(text) {
    return text
      .replace(/-\s*sold out/i, '')
      .replace(/-\s*out of stock/i, '')
      .trim();
  }

  // Select option values can be "OptionName:Color" (e.g. "PolyKnit:White") —
  // pull just the color part, same as the Liquid does for color.label.
  function extractColor(value) {
    const parts = value.split(':');
    return stripStatus(parts[parts.length - 1]);
  }

  function setSwatchVisible(wrapper, visible) {
    wrapper.style.setProperty('display', visible ? 'inline-block' : 'none', 'important');
  }

  function getSegments(text) {
    return text.split('/').map(function (s) { return s.trim(); });
  }

  function getCurrentOtherValues() {
    return otherSelectors.map(function (sel) { return stripStatus(sel.value); });
  }

  function getCheckedColor() {
    const checked = document.querySelector('input[name="color_swatch"]:checked');
    return checked ? checked.dataset.color.trim() : null;
  }

  function findMatchingOption(color, otherValues) {
    return Array.from(variantSelect.options).find(function (opt) {
      const segments = getSegments(opt.text);

      const othersMatch = otherValues.every(function (val) {
        return segments.some(function (seg) { return seg === val; });
      });

      const colorMatch = segments.some(function (seg) {
        const parts = seg.split(':');
        return stripStatus(parts[parts.length - 1]) === color;
      });

      return othersMatch && colorMatch;
    });
  }

  function updateURLVariant(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  function applyMatch(force) {
    const color = getCheckedColor();
    if (!color) return;

    const otherValues = getCurrentOtherValues();
    const option = findMatchingOption(color, otherValues);

    if (option && (force || variantSelect.value !== option.value)) {
      variantSelect.value = option.value;
      variantSelect.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      variantSelect.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      updateURLVariant(option.value);
    }

    // Keep the hidden color select in sync in case any other theme code reads it
    if (colorSelect) {
      const match = Array.from(colorSelect.options).find(function (o) {
        return extractColor(o.value) === color;
      });
      if (match && colorSelect.value !== match.value) {
        colorSelect.value = match.value;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Show/hide swatches based on what's actually available in the color select right now
  function filterSwatches() {
    if (!colorSelect) return;

    const availableColors = Array.from(colorSelect.options).map(function (o) {
      return extractColor(o.value);
    });

    swatches.forEach(function (swatch) {
      const wrapper = swatch.closest('.variant-option__value');
      const color = swatch.dataset.color.trim();
      const isAvailable = availableColors.indexOf(color) !== -1;

      setSwatchVisible(wrapper, isAvailable);
      if (!isAvailable && swatch.checked) {
        swatch.checked = false;
      }
    });

    // If nothing is checked (e.g. the checked color just got hidden), fall back to first visible
    if (!getCheckedColor()) {
      const firstVisible = Array.from(swatches).find(function (s) {
        const wrapper = s.closest('.variant-option__value');
        return wrapper.style.display !== 'none';
      });
      if (firstVisible) {
        firstVisible.checked = true;
        applyMatch();
      }
    }
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('change', ()=>{
      applyMatch();
      syncAddToCartClass();
    });
  });

  otherSelectors.forEach(function (sel) {
    sel.addEventListener('change', function () {
      filterSwatches();
      applyMatch();
      syncAddToCartClass()
    });
  });

  // Catch cases where theme JS rewrites/disables/removes <option>s on the color select dynamically
  if (colorSelect) {
    const observer = new MutationObserver(filterSwatches);
    observer.observe(colorSelect, { childList: true, subtree: true, attributes: true });
  }

  function preselectSwatch() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption) return;

    const segments = getSegments(selectedOption.text);

    swatches.forEach(function (swatch) {
      const color = swatch.dataset.color.trim();
      const isMatch = segments.some(function (seg) {
        const parts = seg.split(':');
        return stripStatus(parts[parts.length - 1]) === color;
      });
      swatch.checked = isMatch;
    });
  }

  preselectSwatch();
  filterSwatches();

  // Fire the variant change event on first load too, not just on user interaction
  applyMatch(true);
  syncAddToCartClass();
  
 otherSelectors.forEach(function (sel) {
  sel.dispatchEvent(new Event('change', { bubbles: true }));
});

// = trigger the swatch's change listener
const checkedSwatch = document.querySelector('input[name="color_swatch"]:checked');
if (checkedSwatch) {
  checkedSwatch.dispatchEvent(new Event('change', { bubbles: true }));
} else {
  syncAddToCartClass();
}
 setTimeout(() => {
    document.querySelector('#SingleOptionSelector-0')?.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }, 1000);
});